import { useEffect, useState } from 'react'

/**
 * Subscribes to a CSS media query and returns whether it currently matches.
 *
 * @example
 * const isDesktop = useMediaQuery("(min-width: 640px)");
 */
export function useMediaQuery(query: string): boolean {
	const [matches, setMatches] = useState(
		() => typeof window !== 'undefined' && window.matchMedia(query).matches,
	)

	useEffect(() => {
		const mq = window.matchMedia(query)
		const handler = (e: MediaQueryListEvent) => setMatches(e.matches)
		mq.addEventListener('change', handler)
		return () => mq.removeEventListener('change', handler)
	}, [query])

	return matches
}
